export type OpcoType = {
  opcoId: OPCO_ID;
  marketId: MARKET_ID;
  // eslint-disable-next-line @typescript-eslint/ban-types
  market: 'GB' | 'US' | 'IE' | 'ES' | (string & {}); // remove string when all the markets are finished
  locale: LOCALE_ID;
  hostUrl: string;
  baseUrl?: string;
  availableLocales: LOCALE_ID[];
  pageTitle: string;
  gtmId: GTM_ID_TYPE;
  opco: OPCO;
  oneTrustCookies?: ONE_TRUST_COOKIES_TYPE;
  defaultLocale: LOCALE_ID;
};

export enum OPCO_ID {
  BAEC = 'baec',
  VYC = 'vyc',
  IBP = 'ibp',
  EIC = 'eic',
  AVIOS = 'avios',
}

export enum OPCO {
  AVIOS = 'avios', // to BA
  BAEC = 'ba', // Future DELETE
  VYC = 'vueling', // Don't know
  IBP = 'iberia', // to IB
  EIC = 'aerclub', // to EI
  /*  BA = 'BA', // Future
  EI = 'EI', // Future
  IB = 'IB', // Future */
}

export enum MARKET_ID {
  US = '1',
  FR = '72',
  IE = '101',
  IT = '103',
  ES = '190',
  GB = '216',
}

export enum LOCALE_ID {
  EN_GB = 'en-GB',
  EN_US = 'en-US',
  EN_IE = 'en-IE',
  ES_ES = 'es-ES',
}

export const DESIGN_TOKENS_OPCO_ID = {
  [OPCO_ID.BAEC]: 'british-airways',
  [OPCO_ID.AVIOS]: 'avios',
  [OPCO_ID.VYC]: 'vueling',
  [OPCO_ID.IBP]: 'iberia',
  [OPCO_ID.EIC]: 'aer-lingus',
};

export const getCBRProgramID: Record<OPCO_ID, number> = {
  [OPCO_ID.BAEC]: 1,
  [OPCO_ID.EIC]: 2,
  [OPCO_ID.VYC]: 3,
  [OPCO_ID.IBP]: 4,
  [OPCO_ID.AVIOS]: 1,
};

export type GTM_ID_TYPE = {
  default: string;
  live: string;
  thirdParty?: string;
};

export type ONE_TRUST_COOKIES_TYPE = {
  test: string;
  live: string;
};
